import type { CSSProperties } from 'react'

/**
 * Widens a page past AppShell's 1080px column to `maxWidth`, centred on <main> (itself centred). Negative inline
 * margins, so the page never grows past the viewport less `gutter` on both sides together; with a gutter of 0 the page
 * goes edge to edge on a narrow screen, cancelling main's own padding.
 */
export function widerThanShell(maxWidth: number, gutter = '0px'): CSSProperties {
  return { marginInline: `calc((100% - min(${maxWidth}px, 100vw - ${gutter})) / 2)` }
}
